import { Theme } from '@infotech-soe/erp-ui-kit';
import { createUseStyles } from 'react-jss';

export default createUseStyles(
  ({ colors: { borderGroup, borderControlHover } }: Theme) => ({
    tBody: {
      display: 'grid !important',
      gridTemplateRows: 'repeat(6, 1fr)',
    },
    dayCell: {
      fontFamily: 'Arial',
      fontWeight: 'bold',
      padding: 5,
      boxSizing: 'border-box',
      userSelect: 'none',
      height: '100%',
    },
    dayCellSelected: {
      outline: `3px solid ${borderControlHover}`,
      outlineOffset: -3,
    },
    hourCell: {
      fontFamily: 'Arial',
      fontWeight: 'bold',
      padding: 5,
      height: '100%',
      '&:focus': {
        outline: `3px solid ${borderControlHover}`,
        outlineOffset: -3,
      },
    },
    dayCellContainer: {
      padding: '0 !important',
      borderRight: `1px solid ${borderGroup} !important`,
      '&:last-child': {
        borderRight: '0px !important',
      },
    },
    hourCellContainer: {
      borderRight: `1px solid ${borderGroup} !important`,
      '&:last-child': {
        borderRight: '0px !important',
      },
    },
    table: {
      border: `1px solid ${borderGroup}`,
    },
    tHead: {
      borderBottom: `solid 1px ${borderGroup}`,
    },
    tHeadTh: {
      borderRight: `solid 1px ${borderGroup} !important`,
      '&:last-child': {
        borderRight: '0px !important',
      },
    },
    trGroup: {
      borderBottom: `solid 1px ${borderGroup} !important`,
      '&:last-child': {
        borderBottom: '0px !important',
      },
    },
  })
);
